/**
 * Check if any required fields have errors
 *
 * Used in Svelte forms, called reactively on every change if the form hasn't been sent and assigned to a variable that keeps track of if fields have errors
 *
 * @param {Object[]} fields - fields to check for errors
 * @return {boolean} do any fields have errors?
 */
function checkIfFieldsHaveErrors(fields) {
  return (
    fields
      // map fields onto array of booleans
      .map(field => (field.error ? true : false))
      // are any of those booleans true?
      .some(err => err === true)
  );
}

export default checkIfFieldsHaveErrors;



// WEBPACK FOOTER //
// ./scripts/util/validation/checkIfFieldsHaveErrors.js